// extracted by mini-css-extract-plugin
module.exports = {"Pill":"Fab_Pill__g57AM","Container":"Fab_Container__6kLXK"};